import React from 'react';
import { Link } from '@tanstack/react-router';

import { isUserAdministrator } from '../../helpers/auth';

import type { Stats } from '../../types/stats';

interface DashboardSidebarNavigationProps {
  stats: Stats;
};

const DashboardSidebarNavigation: React.FC<DashboardSidebarNavigationProps> = ({ stats }) => {
  const totalSprks = stats?.total_sprks || 0;
  const totalMemories = stats?.total_memories || 0;
  const totalTimelines = stats?.total_timelines || 0;
  const totalReceivedSprks = stats?.total_received_sprks || 0;
  const totalReceivedMemories = stats?.total_received_memories || 0;
  const totalContributingTimelines = stats?.total_contributing_timelines || 0;
  const totalReceivedInvitations = stats?.total_received_invitations || 0;
  const totalUsers = stats?.global_total_users || 0;

  return (
    <>
      <div className="page-eyebrow">
        My LGCY
      </div>
      <nav className="wa-stack wa-gap-0">
        <Link to="/dashboard" activeOptions={{ exact: true }}>
          <div className="wa-cluster wa-gap-0">
            <span>
              <i className="fa-regular fa-circle-dot" />
              All
            </span>
            <wa-tag pill size="xs">{totalSprks + totalMemories + totalTimelines}</wa-tag>
          </div>
        </Link>
        <Link to="/dashboard/sprks">
          <div className="wa-cluster wa-gap-0">
            <span>
              <i className="fa-regular fa-bolt" />
              SPRKs
            </span>
            <wa-tag pill size="xs">{totalSprks}</wa-tag>
          </div>
        </Link>
        <Link to="/dashboard/memories">
          <div className="wa-cluster wa-gap-0">
            <span>
              <i className="fa-regular fa-table-layout" />
              Memories
            </span>
            <wa-tag pill size="xs">{totalMemories}</wa-tag>
          </div>
        </Link>
        <Link to="/dashboard/timelines">
          <div className="wa-cluster wa-gap-0">
            <span>
              <i className="fa-regular fa-list-timeline" />
              Timelines
            </span>
            <wa-tag pill size="xs">{totalTimelines}</wa-tag>
          </div>
        </Link>
      </nav>
      <div className="page-eyebrow">
        Shared with me
      </div>
      <nav className="wa-stack wa-gap-0">
        <Link to="/dashboard/received/sprks">
          <div className="wa-cluster wa-gap-0">
            <span>
              <i className="fa-regular fa-bolt" />
              SPRKs
            </span>
            <wa-tag pill size="xs">{totalReceivedSprks}</wa-tag>
          </div>
        </Link>
        <Link to="/dashboard/received/memories">
          <div className="wa-cluster wa-gap-0">
            <span>
              <i className="fa-regular fa-table-layout" />
              Memories
            </span>
            <wa-tag pill size="xs">{totalReceivedMemories}</wa-tag>
          </div>
        </Link>
      </nav>
      <div className="page-eyebrow">
        Activity
      </div>
      <nav className="wa-stack wa-gap-0">
        <Link to="/dashboard/contributing">
          <div className="wa-cluster wa-gap-0">
            <span>
              <i className="fa-regular fa-user-plus" />
              Contributing to
            </span>
            <wa-tag pill size="xs">{totalContributingTimelines}</wa-tag>
          </div>
        </Link>
        <Link to="/dashboard/invitations">
          <div className="wa-cluster wa-gap-0">
            <span>
              <i className="fa-regular fa-message-plus" />
              Invitations
            </span>
            <wa-tag pill size="xs">{totalReceivedInvitations}</wa-tag>
          </div>
        </Link>
      </nav>
      {isUserAdministrator() && (
        <>
          <div className="page-eyebrow">
            Administration
          </div>
          <nav className="wa-stack wa-gap-0">
            <Link to="/dashboard/admin/users">
              <div className="wa-cluster wa-gap-0">
                <span>
                  <i className="fa-regular fa-users" />
                  Users
                </span>
                <wa-tag pill size="xs">{totalUsers}</wa-tag>
              </div>
            </Link>
            <Link to="/dashboard/admin/images">
              <div className="wa-cluster wa-gap-0">
                <span>
                  <i className="fa-regular fa-image" />
                  SPRK Images
                </span>
              </div>
            </Link>
            <Link to="/dashboard/admin/image-groups">
              <div className="wa-cluster wa-gap-0">
                <span>
                  <i className="fa-regular fa-folder-image" />
                  Image Groups
                </span>
              </div>
            </Link>
          </nav>
        </>
      )}
    </>
  );
}

export default DashboardSidebarNavigation;
